import { JobStatus } from '@y42/json-schema';
import { isNullish } from '@y42/util/nullish';
import { GetQuickFilterTextParams, ValueFormatterParams } from 'ag-grid-community';

export const JobStatusValueFormatter = (
  params: ValueFormatterParams | GetQuickFilterTextParams | { value: JobStatus },
) => {
  const value: JobStatus = params.value;

  if (isNullish(value)) {
    return value;
  }

  switch (value) {
    case JobStatus.Pending:
      return 'Pending';
    case JobStatus.Ready:
      return 'Ready';
    case JobStatus.Invalid:
      return 'Invalid';
    case JobStatus.Queued:
      return 'In Queue';
    case JobStatus.New:
      return 'Processing';
    case JobStatus.InvalidPartial:
      return 'Partially Invalid';
    case JobStatus.PartiallyEmpty:
      return 'Partially Empty';
    case JobStatus.PartiallyReady:
      return 'Partially Ready';
    case JobStatus.Expired:
      return 'Expired';
    case JobStatus.Canceled:
      return 'Canceled';
    default:
      const casted = `${value}`;
      return casted.length > 0 ? casted.charAt(0).toUpperCase() + casted.slice(1) : 'Unknown';
  }
};
